
import FullScreenDialog, { FullScreenDialogCloseReason } from "../../../components/full-screen-dialog/FullScreenDialog";
import { BindDialogReturn, DialogProps, DialogResult, DialogState, bindDialog, useDialogState } from "../../../hooks/use-dialog-state/UseDialogState";
import AlarmScheduleEditor from "./AlarmScheduleEditor";

import type { JSX } from "react";

export type AlarmScheduleEditorDialogInitValues = {
    organizationID: number;    
    groupID: number;
    alarmScheduleID: number;

};

export type AlarmScheduleEditorDialogResultValues = {
    AlarmScheduleID: number;
};

export type AlarmScheduleEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "save";

export type AlarmScheduleEditorDialogResult = DialogResult<AlarmScheduleEditorDialogResultValues, AlarmScheduleEditorDialogResultReason>;

export type AlarmScheduleEditorDialogProps = DialogProps<AlarmScheduleEditorDialogInitValues, AlarmScheduleEditorDialogResult>;

export default function AlarmScheduleEditorDialog({
    open,
    onClose,
    values
}: AlarmScheduleEditorDialogProps): JSX.Element {

    return (
        
        values ?
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <AlarmScheduleEditor
                organizationID={values.organizationID}
                groupID={values.groupID}
                alarmScheduleID={values.alarmScheduleID }
                onClose={({
                    reason, 
                }) => onClose({
                    reason: reason,
                    values: {
                        AlarmScheduleID: values?.alarmScheduleID
                    }
                })}
            />
        </FullScreenDialog>
        : <></>
    );
}

export type AlarmScheduleEditorDialogState = DialogState<AlarmScheduleEditorDialogInitValues, AlarmScheduleEditorDialogResult>;
export type BindAlarmScheduleEditorDialogReturn = BindDialogReturn<AlarmScheduleEditorDialogInitValues, AlarmScheduleEditorDialogResult>;

export function useAlarmScheduleEditorDialogState(): AlarmScheduleEditorDialogState {
    return useDialogState();
}

export function bindAlarmScheduleEditorDialog(props: AlarmScheduleEditorDialogState): BindAlarmScheduleEditorDialogReturn {
    return bindDialog(props);
}
